import React from 'react';

import styled from '@emotion/styled';

const CenteredContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingSpinner = () => <img src="ajax-loader.gif" alt="Loading..." />;

export const LoadingIndicator = () => (
  <CenteredContentWrapper>
    <LoadingSpinner />
  </CenteredContentWrapper>
);

const FullPageWrapper = styled.div`
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FullPageLoader = () => (
  <FullPageWrapper>
    <LoadingSpinner />
  </FullPageWrapper>
);
